import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  message: null,
  messageType: null,
  showMessage: false,
  noteText: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const notesSlice = createSlice({
  name: "notes",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoader = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoader = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // organizations loader
    notesListLoading: (state, action) => {
      state.listLoader = action.payload;
    },
    notesList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    setEditClick: (state, action) => {
      state.noteText = action.payload;
    },
  },
});
